/**
 * Le code-barres fait foi (29/10/2026) : copie de `api/src/common/ean-conflit.ts`
 * — les deux bougent ensemble.
 *
 * Seuls deux EAN-13 à la clé juste, hors codes internes (préfixe 2), peuvent
 * être « en conflit » : le vrac porte notre 200004…, le sac du fournisseur le
 * sien, c'est le même produit.
 */
function ean13(code: string | null | undefined): string | null {
  const c = (code || '').trim();
  if (!/^\d{13}$/.test(c) || c.startsWith('2')) return null;
  const somme = c
    .slice(0, 12)
    .split('')
    .reduce((s, ch, i) => s + Number(ch) * (i % 2 === 0 ? 1 : 3), 0);
  return (10 - (somme % 10)) % 10 === Number(c[12]) ? c : null;
}

export function eanConflit(
  eanLigne: string | null | undefined,
  eanFiche: string | null | undefined,
): boolean {
  const ligne = ean13(eanLigne);
  const fiche = ean13(eanFiche);
  return !!ligne && !!fiche && ligne !== fiche;
}
